var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDesktop)?_c('div',[_c('video',{staticClass:"questionnaire-slider__video",attrs:{"muted":"","playsinline":"","preload":"metadata"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }